import { render, staticRenderFns } from "./workbook_content.vue?vue&type=template&id=aa20add0&scoped=true&"
import script from "./workbook_content.vue?vue&type=script&lang=js&"
export * from "./workbook_content.vue?vue&type=script&lang=js&"
import style0 from "./workbook_content.vue?vue&type=style&index=0&id=aa20add0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa20add0",
  null
  
)

export default component.exports